import HowToStepsCard from 'components/HowToStepsCard';
import QuestionAccordion from './QuestionAccordion';
import { Apps } from 'constants/global';

const stepsTitleMap = {
  [Apps.BOT_BUILDER]: 'How to setup a bot with',
  [Apps.CHAT_WITH_DOCS]: 'How to chat with documents with',
  [Apps.BLOG_WRITER]: 'How to generate blogs with',
  [Apps.EMAIL_GENERATOR]: 'How to generate emails with',
  [Apps.TEXT_TO_IMAGE]: 'How to generate images with',
  [Apps.TEXT_TO_LOGO]: 'How to generate logos with',
  [Apps.STICKER_MAKER]: 'How to create stickers with',
  [Apps.GIF_MAKER]: 'How to create GIFs with',
  [Apps.TRANSCRIPT_GENERATOR]: 'How to generate a transcripts with',
  [Apps.TEXT_TO_SPEECH]: 'How to convert text to speech with',
  [Apps.UPSCALE_IMAGE]: 'How to upscale images with',
  [Apps.OBJECT_REMOVER]: 'How to remove objects from images with',
  [Apps.OBJECT_REPLACER]: 'How to replace objects in an image with',
  [Apps.BRANDBOOK]: 'How to create a brandbook with',
  [Apps.PODCAST]: 'How to generate podcasts with',
  [Apps.SOCIAL_MEDIA]: 'How to make social media posts with',
  [Apps.IMAGE_TO_IMAGE]: 'How to transform images with',
};

const Questions = ({ appType }: { appType: Apps }) => {
  return (
    <section className="p-5 md:pb-16 md:pt-0 text-text-primary bg-background w-full">
      <div className="flex flex-col max-w-[1260px] mx-auto">
        <HowToStepsCard howToTitle={stepsTitleMap[appType]} appType={appType} />
        <div className="w-full flex flex-col gap-3 justify-between mt-5">
          <h3 className="font-bold text-xl md:text-[28px] md:px-4 text-left">
            Common questions
          </h3>
          <div className="w-full bg-background md:p-4 pb-20 md:pb-10">
            <QuestionAccordion appType={appType} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Questions;
